module.exports = __webpack_public_path__ + "img/big-blue-video.149b7423.svg";